import { AssessmentCriteria } from './assessment-criteria';

export class Workprocess {
    public naam: string;
    public id: number;
    public creboId: number;
    public code: string;
    public omschrijving: string;
    public geldigVanaf: string;
    public geldigTot: string;
    public resultaatWerkproces: string;
    public opmerkingen: string;
    public done: boolean;
    public beoordelingsvorm: AssessmentCriteria[];
    public mogelijkeResultaten: any[];
    public cijferWerkproces: number;
    public kerntaakId: string;
    public percentageGrensWaardeVoldoende: string;
    public aantalVoldaan: string;
    public aantalOnvoldoendes: string;
    public totaalAantalBeoordelingsCriteria: string;
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/workprocess.ts